<template>
    <div id="div_home">
        <p>
        I am a Research Scientist at <a style="text-decoration: none; color: #bb0000;" href="https://usa.visa.com/about-visa/visa-research.html">Visa Research</a>. I received my Ph.D. degree from the <a style="text-decoration: none; color: #bb0000;" href="http://www.cse.osu.edu/">Dept. of Computer Science and Engineering</a>, <a style="text-decoration: none; color: #bb0000;" href="http://www.osu.edu/">the Ohio State University</a>. Before that, I received my M.S. degree in Computer Science from <a style="text-decoration: none; color: #bb0000;" href="http://www.vt.edu/">Virginia Tech</a>, and the B.Eng. degree in Software Engineering from <a style="text-decoration: none; color: #bb0000;" href="http://www.nankai.edu.cn/english/">Nankai University</a>.
        </p>
        <p>
        My research interests are broadly in <em>visualization, visual analytics, explainable AI</em>, with focuses on the following topics (with representative publications):
        <ul>
            <li v-for="area in areas" class="li_topic">{{ area.name }}:<br>
                [<a v-for="(work, index) in area.works" v-bind:href="requestLocalData(work.href)" class="li_paper">
                     {{ work.abbr}}
                     <span v-if="index != Object.keys(area.works).length-1">|</span>
                </a>]
            </li>
        </ul>  
        </p>
        <p id="p_keytag">Research keywords from the abstracts of my recent publications:</p>
        <img src="../assets/cloud.jpg" style="width:95%; border-radius:2px">
    </div>
</template>

<script>
// Imports

export default {
    data () {
        return {
            blog: {
                title: '',
                content: '',
                categories: [],
                // author: ''
            },
            areas: [
                {
                    name: 'Explainable AI (VIS+ML)',
                    works: [
                        {
                            abbr: 'Book',
                            href: 'https://link.springer.com/book/10.1007/978-3-031-75340-4'
                        },
                        {
                            abbr: 'Survey',
                            href: 'https://arxiv.org/abs/2307.07712'
                        },
                        {
                            abbr: 'GANViz',
                            href: 'https://www.researchgate.net/publication/323888761_GANViz_A_Visual_Analytics_Approach_to_Understand_the_Adversarial_Game'
                        },
                        {
                            abbr: 'DQNViz',
                            href: 'https://www.researchgate.net/publication/327455530_DQNViz_A_Visual_Analytics_Approach_to_Understand_Deep_Q-Networks'
                        },
                        {
                            abbr: 'DeepVID',
                            href: 'https://www.researchgate.net/publication/331794108_DeepVID_Deep_Visual_Interpretation_and_Diagnosis_for_Image_Classifiers_via_Knowledge_Distillation'
                        },
                        {
                            abbr: 'DRLive',
                            href: 'https://www.researchgate.net/publication/351063473_Visual_Analytics_for_RNN-Based_Deep_Reinforcement_Learning'
                        },
                        {
                            abbr: 'ViT Visualization',
                            href: 'https://arxiv.org/abs/2303.13731'
                        },
                    ]
                },
                {
                    name: 'Ensemble Learning (e.g., Tree Boosting) & Model Ensembling',
                    works: [
                        {
                            abbr: 'VISTB',
                            href: 'https://www.researchgate.net/publication/350789266_Investigating_the_Evolution_of_Tree_Boosting_Models_with_Visual_Analytics'
                        },
                        {
                            abbr: 'LFD',
                            href: 'https://arxiv.org/pdf/2201.07849.pdf'
                        }
                    ]
                },
                {
                    name: 'Ensemble Visualization (for Scientific Simulations)',
                    works: [
                        {
                            abbr: 'Survey',
                            href: 'https://www.researchgate.net/publication/326241623_Visualization_and_Visual_Analysis_of_Ensemble_Data_A_Survey'
                        },
                        {
                            abbr: 'InSituNet',
                            href: 'https://arxiv.org/abs/1908.00407'
                        },
                        {
                            abbr: 'Nested PCP',
                            href: 'https://www.math.purdue.edu/~lin491/pub/GLIN-16-IEEE_TVCG-2.pdf'
                        },
                        {
                            abbr: 'CECAV-DNN',
                            href: 'https://www.sciencedirect.com/science/article/pii/S2468502X20300164'
                        },
                    ]
                },
                {
                    name: 'GPGPU and Large Volume Visualization',
                    works: [
                        {
                            abbr: 'Warp Marching',
                            href: 'https://www.sciencedirect.com/science/article/pii/S2468502X1730027X#:~:text=We%20introduce%20a%20new%20sampling,the%20performance%20(Section%204).'
                        },
                        {
                            abbr: 'Cache Optimization',
                            href: 'assets/paperData/14_ldav.pdf'
                        },
                        {
                            abbr: 'Cylindrical Structures',
                            href: 'assets/paperData/15_ldav.pdf'
                        }
                    ]
                }
            ],
            // authors: ['The Net Ninja', 'The Angular Avenger', 'The Vue Vindicator'],
            submitted: false
        }
    },
    methods: {
        post: function(){
            this.$http.post('http://jsonplaceholder.typicode.com/posts', {
                title: this.blog.title,
                body: this.blog.content,
                userId: 1
            }).then(function(data){
                console.log(data);
                this.submitted = true;
            });
        },
        requestLocalData(data) {
            if(data.slice(0, 4) == "http") {
                return data; // public url
            }
            else {// from local folder
                return require('../'+data);
            }
        }
    }
}
</script>

<style scoped>
#div_home *{
    box-sizing: border-box;
}
#div_home{
    margin: 15px auto;
    /* max-width: 700px; */
    padding-left: 10px;
    border-left: 2px solid #eeeeee;
    border-style: none none none solid;
}
#p_keytag {
    /* font-weight: bold; */
    /* font-size: 18px; */
}
.li_topic {
    /* font-style: italic; */
}

.li_paper {
    text-decoration: none; 
    color: #bb0000;
    font-size: 13.5px;
    font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue